var _linearGradient;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGradientUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "15px",
    viewBox: "0 0 18 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradientCrown",
    gradientTransform: "rotate(45)",
    height: "100%",
    width: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "var(--page-header-gradient-color-2)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "var(--page-header-gradient-color-1)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF08-Style-Guides",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Guide",
    transform: "translate(-69.000000, -300.000000)",
    fill: "#858199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group-2",
    transform: "translate(66.000000, 199.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/Upload",
    transform: "translate(0.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.625,10.7375 C17.625,10.7375 17.625,10.625 17.625,10.625 C17.625,7.475 15.15,5 12,5 C9.1875,5 6.825,7.025 6.4875,9.8375 C4.4625,10.5125 3,12.3125 3,14.5625 C3,17.375 5.25,19.625 8.0625,19.625 C9.975,19.625 14.7,19.625 16.5,19.625 C18.975,19.625 21,17.6 21,15.125 C21,12.9875 19.5375,11.3 17.625,10.7375 Z M13.125,14 L13.125,17.375 L10.875,17.375 L10.875,14 L7.5,14 L12,9.5 L16.5,14 L13.125,14 Z",
    id: "Fill",
    fillRule: "evenodd",
    style: {
      fill: "url(#gradientCrown)"
    }
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGradientUpload);
export default __webpack_public_path__ + "static/media/iconGradientUpload.96dbd7d8.svg";
export { ForwardRef as ReactComponent };